import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { useLocation, useParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';

import Loader from '@components/Loader';
import Albums from '@components/Albums';
import SearchBar from '@components/SearchBar';
import Layout from '@containers/Layout';
import { FlexListBox, List, Pagination } from '@styles/globalStyles';

const LabelsPage = ({
  musicStore: {
    albums,
    downloadBatch,
    isLoading,
    page,
    search,
    searchPhrase,
    switchPage,
    toggleView,
    totalPages,
    view,
    resetAlbums,
    fetchData,
    updateSelectedAlbums,
    order,
    downloadGoogleApis,
    labels,
  },
}) => {
  const { search: locationSearch } = useLocation();
  const { uuid, kind } = useParams();

  const stems = kind === 'stems';

  const activeLabel = labels.find(label => label.uuid === uuid) || {};

  useEffect(() => {
    const getAlbums = async () => {
      await fetchData(uuid, stems);
    };

    if (uuid) {
      getAlbums();
    }
  }, [locationSearch, uuid, stems]);

  useEffect(() => {
    return () => {
      resetAlbums();
    };
  }, []);

  return (
    <Layout>
      <FlexListBox fullwidth view={view} loading={isLoading ? 1 : 0}>
        {isLoading ? <Loader cover /> : null}
        <SearchBar
          view={view}
          toggleView={toggleView}
          search={search}
          searchPhrase={searchPhrase}
          downloadGoogleApis={downloadGoogleApis}
          activeLabel={activeLabel}
          kind="labels"
        />
        <List view={view}>
          <Albums
            items={albums}
            view={view}
            updateSelectedAlbums={updateSelectedAlbums}
            downloadBatch={downloadBatch}
            order={order}
          />
        </List>
        <Pagination>
          <ReactPaginate
            pageCount={totalPages}
            pageRangeDisplayed={10}
            onPageChange={({ selected }) => switchPage(selected)}
            forcePage={page - 1}
          />
        </Pagination>
      </FlexListBox>
    </Layout>
  );
};

export default inject('musicStore')(observer(LabelsPage));
